import { Validator } from "@angular/forms/src/directives/validators";
import { Directive, Input } from "@angular/core";
import { NG_VALIDATORS } from "@angular/forms";
import { AbstractControl } from "@angular/forms";

@Directive({
  selector: '[forbiddenDateValidator]',
  providers: [{
    provide: NG_VALIDATORS,
    useExisting: ForbiddenDateValidatorDirective,
    multi: true
  }]
})


export class ForbiddenDateValidatorDirective implements Validator {
  @Input() forbiddenDateValidator: string;
  validate(control: AbstractControl): { [key: string]: any } | null {
    let next = this.forbiddenDateValidator.replace('b', 'a');
    const controlToCompare = control.parent.get(next);
    if (control.value == null) return null;
    if (controlToCompare && controlToCompare.value) {
      if (control.value.year > controlToCompare.value.year) {
        return null;
      }
      else if (control.value.month > controlToCompare.value.month) {
        return null;
      }
      else if (control.value.day > controlToCompare.value.day) {
        return null;
      }
      return { 'incorrectDate': true };
    }
  }
}




	
